export var Partner;
(function (Partner) {
    Partner["FOOL"] = "fool";
    Partner["FORBES"] = "forbes";
    Partner["MILLIONACRES"] = "millionacres";
    Partner["SEEKING_ALPHA"] = "seeking_alpha";
    Partner["SEEKING_ALPHA_IFRAME"] = "seeking_alpha_iframe";
    Partner["STREET_AUTHORITY"] = "street_authority";
    Partner["THE_STREET"] = "the_street";
    Partner["WEALTHTRACK"] = "wealthtrack";
})(Partner || (Partner = {}));
